module.exports = __webpack_public_path__ + "img/main_menu_guide.a99a618f.svg";